function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Massage Table Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M18.22996,0.4552 C19.2921635,0.4552 20.15952,1.3222386 20.15952,2.38476 L20.15952,2.49192 C20.15952,3.55390237 19.2919424,4.42148 18.22996,4.42148 L17.852,4.4212 L17.7454684,10.9235558 C17.7414397,11.1689827 17.5612377,11.3702006 17.3273251,11.408749 L17.2373294,11.4153481 C16.9612242,11.4107499 16.7410708,11.1832483 16.7456031,10.9071431 L16.7456031,10.9071431 L16.799,7.6322 L12.156,4.4212 L8.502,4.4212 L3.853,7.6362 L3.79901238,10.9235558 C3.79498371,11.1689827 3.61478174,11.3702006 3.3808691,11.408749 L3.29087336,11.4153481 C3.01476818,11.4107499 2.79461483,11.1832483 2.79914707,10.9071431 L2.79914707,10.9071431 L2.906,4.4212 L2.42956,4.42148 C1.36757763,4.42148 0.5,3.55390237 0.5,2.49192 L0.5,2.38476 C0.5,1.3222386 1.36735654,0.4552 2.42956,0.4552 L18.22996,0.4552 Z M16.852,4.4212 L13.915,4.4212 L16.819,6.4292 L16.852,4.4212 Z M6.744,4.4212 L3.905,4.4212 L3.873,6.4062 L6.744,4.4212 Z M18.22996,1.4552 L2.42956,1.4552 C1.91955923,1.4552 1.5,1.87460544 1.5,2.38476 L1.5,2.49192 C1.5,3.00161762 1.91986237,3.42148 2.42956,3.42148 L3.3321949,3.42194801 L3.3321949,3.42194801 L3.42219064,3.41534807 C3.44252797,3.41568697 3.46256174,3.41723522 3.48222451,3.41992315 L17.2786509,3.42194801 L17.2786509,3.42194801 L17.3686466,3.41534807 C17.3890989,3.41568889 17.4092441,3.41725275 17.4290137,3.41996882 L18.22996,3.42148 C18.7396576,3.42148 19.15952,3.00161762 19.15952,2.49192 L19.15952,2.38476 C19.15952,1.87460544 18.7399608,1.4552 18.22996,1.4552 Z",
  id: "massage-table-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "massage-table-Icon/Global/MassageTable",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "massage-table-Swatches/Midnight",
  transform: "translate(2.000000, 6.044800)"
}, /*#__PURE__*/React.createElement("use", {
  id: "massage-table-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#massage-table-path-1"
})));

var SvgMassageTable = function SvgMassageTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMassageTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/massage-table.380e3605.svg";
export { ForwardRef as ReactComponent };